import { Component, OnInit, TemplateRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AdminService } from '../services/admin.service';
import { ConstantsService } from '../services/constants.service';
import { environment } from '../../environments/environment';
import { DataService } from '../services/data.service';
import { UrlConstants } from '../services/url-constants';
import { Router } from '@angular/router';
import { AdminEditComponent } from '../admin-edit/admin-edit.component';

@Component({
  selector: 'app-admin-offline',
  templateUrl: './admin-offline.component.html',
  styleUrls: ['./admin-offline.component.scss'],
})
export class AdminOfflineComponent implements OnInit {
  public videos: any = [];
  public currentUrl;
  public uploadedVideos = [];
  public isChecked = false;
  public videoList = [];
  public profilePicture;
  public isLoading = false;
  public isProcessing = false;
  public uploadSkeltonArray = [];
  public isdisabled = false;
  public deletedisable = true;
  public urlPrefix = environment.S3_URL_PRFIX;
  public folderName = this.constants.UPLOADEDTOVIEO_TXT;
  public sThreeFolder = 'pending';
  public liveVideo = true;
  public offlineVideo = false;
  public liveVideosArray = [];
  public liveVideos = [];
  public changeDetect = [];
  public submitVideosList = [];
  public nameUpdateSuccess = false
  public errorAlert = false;
  public errorAlertMessage = '';
  public successAlert = false;
  public successAlertMessage = '';
  count = 0;
  p: number = 1;
  videoTitle: any;
  startKey: any = null;
  previousKey = [];
  clickForward: boolean = true;
  lastEvaluatedKeyArr: any = [];
  isMakeLive = false;
  constructor(
    public constants: ConstantsService,
    private adminservice: AdminService,
    private dataService: DataService,
    private urlConstants: UrlConstants,
    private router: Router,
    public dialog: MatDialog,

  ) {
    var uploadSkelton = [
      constants.UPLOADED_SKELTON_IMG,
      constants.UPLOADED_SKELTON_IMG,
      constants.UPLOADED_SKELTON_IMG,
      constants.UPLOADED_SKELTON_IMG,
      constants.UPLOADED_SKELTON_IMG,
      constants.UPLOADED_SKELTON_IMG,
      constants.UPLOADED_SKELTON_IMG,
      constants.UPLOADED_SKELTON_IMG,
      constants.UPLOADED_SKELTON_IMG,
      constants.UPLOADED_SKELTON_IMG,
      constants.UPLOADED_SKELTON_IMG,
      constants.UPLOADED_SKELTON_IMG,
      constants.UPLOADED_SKELTON_IMG,
      constants.UPLOADED_SKELTON_IMG,
      constants.UPLOADED_SKELTON_IMG,
      constants.UPLOADED_SKELTON_IMG,
      constants.UPLOADED_SKELTON_IMG,
      constants.UPLOADED_SKELTON_IMG,
      constants.UPLOADED_SKELTON_IMG,
      constants.UPLOADED_SKELTON_IMG,
    ];
    this.uploadSkeltonArray = uploadSkelton;
  }

  ngOnInit(): void {
    this.paginateLoad();
  }
  // load = async () => {
  //   await this.adminservice
  //     .getUploadedVideo()
  //     .then((data) => {
  //       // this.videos = data;
  //       this.sThreeFolder = 'uploadedToVimeo';
  //       this.uploadedVideos = this.videos;
  //       // this.startKey = data[1].LastEvaluatedKey;
  //       this.previousKey.push(this.startKey);
  //       let i = 0;
  //       this.isLoading = false;
  //     })
  //   this.adminservice.getVideoList('uploadedToVimeo')
  //   this.adminservice.cast.subscribe((data) => {
  //     this.submitVideosList = data['Items'];
  //   });
  // };
  async paginateLoad() {
    this.isLoading = true;
    const params = [
      { param: '{actionName}', value: 'paginateAdminUpload' }
    ]
    const postdata = {
      "campaignId": "window",
      "LastEvaluatedKey": this.startKey !== null ? this.startKey : null,
    }
    this.dataService.postData(this.urlConstants.getUri(this.urlConstants.action, params), postdata).subscribe((data: any) => {
      let { Items } = data.res;
      this.videos = [...this.videos, ...Items];
      this.sThreeFolder = 'uploadedToVimeo';
      this.uploadedVideos = this.videos;
      this.getLastEvekey(data, postdata);
      this.clickForward ? this.lastEvaluatedKeyArr.push(data['res'].LastEvaluatedKey) : '';
      if (data['res'].LastEvaluatedKey === undefined) this.startKey = undefined;
      let i = 0;
      this.isLoading = false;
    }, (error) => {
      this.isLoading = false;
      this.errorAlert = true;
      this.errorAlertMessage = this.constants.FETCH_ERROR;
    })
  }

  getLastEvekey(data, postdata) {
    if (data['res'].LastEvaluatedKey !== null) {
      postdata.LastEvaluatedKey = data['res'].LastEvaluatedKey;
      this.startKey = postdata.LastEvaluatedKey;

    }
  }
  async onClickupdateStats() {
    let startIndex = this.p * 250 - 250;
    let lastIndex = this.p * 250;
    let selectedItems = this.uploadedVideos.slice(startIndex, lastIndex);
    if (selectedItems.length === 0) {
      this.errorAlert = true;
      this.errorAlertMessage = 'Please select atleast one video';
    } else {
      if (selectedItems.length > 250) {
        this.errorAlert = true;
        this.errorAlertMessage = 'Large list, Please select maximum 250 videos at a time';
      } else {
        this.isdisabled = true;
        const postParams = [{ param: '{actionName}', value: 'updateStats' }];
        const postdata = selectedItems;
        await this.dataService
          .postData(this.urlConstants.getUri(this.urlConstants.action, postParams), postdata)
          .subscribe(data => {
            this.successAlert = true;
            this.isProcessing = false;
            this.successAlertMessage = 'Finished'
            this.isdisabled = false;
            this.videoList = [];
            this.isChecked = false;
            this.uploadedVideos.forEach((el) => {
              el.isTicked = false;
            })
            this.isMakeLive = false;
          }, error => {
            this.isdisabled = false;
          });
      }
    }
  }
  private setting = {
    element: {
      dynamicDownload: null as HTMLElement,
    },
  };
  onClickVideoTitle(item, event) {
    let shareUrl = `${window.location.origin}/Window/${item.videoId}`;
    navigator.clipboard.writeText(shareUrl).then(function () {
      window.open(`/Window/${item.videoId}`, '_blank');
    });
    document.getElementById(`${event.target.id}`).innerHTML = 'url copied';
  }
  onSelectTbleRow(video, event) {
    if (event.target.checked) {
      this.isMakeLive = true;
      this.videoList.push({
        url1: video.url1
      });
      for (let i = 0; i < this.uploadedVideos.length; i++) {
        if (video.url1 == this.uploadedVideos[i].videoId) {
          this.uploadedVideos[i].isChecked = true;
          break;
        }
      }
    } else {
      this.videoList = this.videoList.filter((data) => data.url1 !== video.url1);
      if (this.videoList.length == 0) {
        this.isMakeLive = false;
      }
      for (let i = 0; i < this.uploadedVideos.length; i++) {
        if (video.url1 == this.uploadedVideos[i].videoId) {
          this.uploadedVideos[i].isChecked = false;
          break;
        }
      }
    }
  }
  Search() {
    this.p=1;
    if (this.videoTitle === '') {
      this.isLoading = true;
      setTimeout(() => {
        this.isLoading = false;
      }, 4000);
      this.videos = this.videos;
    } else {
      this.uploadedVideos = this.uploadedVideos.filter((res) => {
        return res.videoTitle
          .toLowerCase()
          .match(this.videoTitle.toLowerCase());
      });
    }
  }
  async onClickMakeLive() {
    if (this.videoList.length === 0) {
      this.errorAlert = true;
      this.errorAlertMessage = 'List is empty';
    } else {
      this.isProcessing = true;
      const postParams = [{ param: '{actionName}', value: 'makeVideoLive' }];
      const postdata = { selectedVideos: this.videoList };
      this.dataService
        .postData(this.urlConstants.getUri(this.urlConstants.action, postParams), postdata)
        .subscribe(data => {
          this.isProcessing = false;
          this.successAlert = true;
          this.successAlertMessage = 'Finished'
          this.videoList = [];
          this.isChecked = false;
          this.videos=[]
          this.startKey = null;
          this.paginateLoad();
        }, error => {
          this.isProcessing = false;
          this.videoList = [];
          this.isChecked = false;
          this.errorAlert = true;
          this.errorAlertMessage = 'Updation Error';
        });
    }
  }
  closeErrorAlert() {
    this.errorAlert = false;
  }
  closeSuccessAlert() {
    document.getElementById('videoTitle').innerHTML = '';
    this.successAlert = false;
  }
  key: string = 'id';
  reverse: boolean = false;
  sort(key) {
    this.key = key;
    this.reverse = !this.reverse;
  }
  onClickName(video) {
    let data = {
      email: video.emailId,
      name: video.author,
      admin: true
    }
    this.adminservice.shareUserData(data);
    this.router.navigate(['./user/mywindow'])
  }

  openDialog(templateRef: TemplateRef<any>) {
    this.dialog.open(templateRef,{ panelClass: 'admin-dialog'});
  }



  async onClickDelete(item) {
    this.deletedisable = false;
    document.getElementById(item.videoId).style.opacity = "50%"
    const params = [{ param: '{object}', value: 'videos' }];
    const bodyObj = {
      campaignId: item.campaignId,
      videoId: item.videoId,
      vimeoToken: item.vimeoToken
    };
    try {
      this.dataService
        .postData(
          this.urlConstants.getUri(this.urlConstants.deleteItem, params), JSON.stringify(bodyObj))
        .subscribe(async (data) => {
          window.location.reload()
        }, error => {
          document.getElementById(item.videoId).style.opacity = "100%"
          this.deletedisable = true
        })
    } catch (e) {
      // console.log('error------0', e);
    }
  }
  onClickEdit(data) {
    let dialogRef = this.dialog.open(AdminEditComponent, {
      data: data,
      panelClass: 'admin-dialog'
    })
    dialogRef.afterClosed().subscribe(result => {
      this.uploadedVideos.filter((res) => {
        if (res.videoId === result.videoId) {
          res.cityLocation = result.cityLocation
          res.author = result.author
          res.Animals = result.Animals
          res.DayVideo = result.DayVideo
          res.Interiors = result.Interiors
          res.Water =  result.Water
          res.Nature = result.Nature
          res.Night = result.Night
          res.Rain = result.Rain
          res.Snow = result.Snow
        }
      })
      this.nameUpdateSuccess = true;
    })
  }
}

